import MaterialsTable from './MaterialsTable'

export default MaterialsTable
